import { useEffect } from 'react'
import { useTrivia } from '../../contexts/trivia-context'
import PreferencesPicker from './pref-picker'
import TriviaList from './trivia-list'

const Trivia = () => {
  const [trivia] = useTrivia()

  useEffect(() => {
    const event = new CustomEvent('background-color', {
      detail: {
        shouldUseWhiteBg: true,
        from: 'trivias page load'
      }
    })

    window.dispatchEvent(event)
  }, [])

  if (!trivia.interests.length) {
    return <PreferencesPicker />
  }

  return <TriviaList />
}

export default Trivia
